import React, { type FC } from 'react';

import ShareToSlack from '@atlassian/integrations';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import type { FlagDescriptor } from '@confluence/flags/entry-points/FlagsStateContainer';

export type ShareToSlackDialogBodyProps = {
	onCloseSlack: () => void;
	showFlag: (flag: Omit<FlagDescriptor, 'id'>) => Promise<FlagDescriptor>;
};

export const ShareToSlackDialogBody: FC<ShareToSlackDialogBodyProps> = ({
	onCloseSlack,
	showFlag,
}) => {
	const { cloudId } = useSessionData();

	return (
		<ShareToSlack
			showFlag={showFlag}
			product="confluence"
			onClose={onCloseSlack}
			changeTab={() => {}}
			cloudId={cloudId}
			hideCopyButton
		/>
	);
};
